export default __webpack_public_path__ + "static/media/product-4l.33aebefe.png";